import { render, staticRenderFns } from "./RateFraudFreeBanner.vue?vue&type=template&id=42247a8e&scoped=true&"
import script from "./RateFraudFreeBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RateFraudFreeBanner.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RateFraudFreeBanner.vue?vue&type=style&index=0&id=42247a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42247a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42247a8e')) {
      api.createRecord('42247a8e', component.options)
    } else {
      api.reload('42247a8e', component.options)
    }
    module.hot.accept("./RateFraudFreeBanner.vue?vue&type=template&id=42247a8e&scoped=true&", function () {
      api.rerender('42247a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/rate-fraud-free/index/RateFraudFreeContent/components/RateFraudFreeBanner.vue"
export default component.exports